module.exports = __webpack_public_path__ + "static/media/blog-category3.7088f489.png";